import React, { Suspense } from 'react';
import { Lazy } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';

import { PRODUCT_TYPE_E_COUPON } from '~/domains/e-coupon/constants';
import ECouponProductCard from '~/domains/products/components/ECouponProductCard';
import { useFrequentlyOrderProducts } from '~/domains/products/queries';
import { useLinkComponent } from '~/hooks/mobileApp';

import FrequentlyOrderedProductCard from './FrequentlyOrderedProductCard';

import { MoreIcon } from '~/assets/icons';

const FrequentlyItemSkeleton = () => (
  <div className="my-24">
    <div className="mb-16 flex items-center justify-between px-20">
      <div className="h-24 w-120 rounded bg-gray-200 skeleton" />
    </div>
    <div className="flex gap-12 overflow-x-auto px-20">
      {[
        'skeleton-1',
        'skeleton-2',
        'skeleton-3',
        'skeleton-4',
        'skeleton-5',
      ].map((id) => (
        <div
          key={id}
          className="size-[140px] shrink-0 rounded-12 bg-gray-200 skeleton"
        />
      ))}
    </div>
  </div>
);

const FrequentlyItem = () => {
  const LinkComponent = useLinkComponent();
  const { data } = useFrequentlyOrderProducts();

  if (!data?.length) {
    return <></>;
  }

  return (
    <div className="my-24">
      <div className="mb-16 flex items-center justify-between px-20">
        <h2 className="text-paragraph typo-heading100">자주 구매한 상품</h2>
        <LinkComponent
          href="/offers/frequently-ordered"
          className="ml-8 shrink-0"
        >
          <span className="flex items-center text-blue-800 typo-paragraph100-regular">
            전체보기
            <MoreIcon />
          </span>
        </LinkComponent>
      </div>

      <div>
        <Swiper modules={[Lazy]} slidesPerView="auto" lazy>
          {data.slice(0, 10).map((product) => {
            return (
              <SwiperSlide
                key={product.offerId}
                className="ml-12 !w-[140px] first-of-type:ml-20 last-of-type:mr-20"
              >
                {product.productType === PRODUCT_TYPE_E_COUPON ? (
                  <ECouponProductCard
                    {...product}
                    eventOption={{
                      detailedPlaceMent: '자주구매한상품',
                    }}
                    reverseCouponDiscountedPrice
                    useOrderCount
                  />
                ) : (
                  <FrequentlyOrderedProductCard
                    {...product}
                    eventOption={{
                      detailedPlaceMent: '자주구매한상품',
                    }}
                    reverseCouponDiscountedPrice
                    plusMembershipFullBadge
                  />
                )}
              </SwiperSlide>
            );
          })}
        </Swiper>
      </div>
    </div>
  );
};
function MarketHomeFrequently() {
  return (
    <Suspense fallback={<FrequentlyItemSkeleton />}>
      <FrequentlyItem />
    </Suspense>
  );
}

export default MarketHomeFrequently;
